/**
 * Default export pour l'auto-discovery `apps/web/src/routes/modules.ts`.
 *
 * Format imposé par `ModuleRoute` (cf. modules.ts) : { path, label, icon,
 * element, children? } — même patron que `herbo-kpi-entrepot/web/route.tsx`.
 * `icon` en kebab-case (converti en PascalCase par `LucideIcon`, cf.
 * `apps/web/src/components/ui/LucideIcon.tsx`), même convention que tous les
 * autres modules (`'shopping-cart'`, `'bar-chart-3'`, …).
 */

import { lazy, Suspense, type ReactNode } from 'react';
import type { ModuleRoute } from '@herbo/module-route';

const CodesEan = lazy(() => import('./pages/CodesEan'));

function withSuspense(node: ReactNode): ReactNode {
  return <Suspense fallback={<CodesEanFallback />}>{node}</Suspense>;
}

function CodesEanFallback(): JSX.Element {
  return (
    <div className="px-6 py-8 text-sm text-slate-500">
      Chargement du module Codes EAN…
    </div>
  );
}

const route: ModuleRoute = {
  path: 'codes-ean',
  label: 'Codes EAN',
  icon: 'barcode',
  element: withSuspense(<CodesEan />),
};

export default route;
